export default {
  user: {},
  logged: false,
  menu: {},
  apiToken: ''
}
